var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNvidia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a3414689-ccfa-456d-a148-ba0f693a5353",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-cb8f7283-5399-4896-9978-dc0497136535 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-cb8f7283-5399-4896-9978-dc0497136535",
    d: "M13.75,13.64v-1.05c.1,0,.21-.01.31-.01,2.89-.09,4.78,2.48,4.78,2.48,0,0-2.04,2.83-4.23,2.83-.29,0-.58-.05-.85-.14v-3.2c1.12.14,1.35.63,2.02,1.76l1.5-1.26s-1.1-1.44-2.95-1.44c-.2,0-.39,0-.59.03M13.75,10.16v1.57l.31-.02c4.01-.14,6.63,3.29,6.63,3.29,0,0-3,3.65-6.13,3.65-.27,0-.54-.03-.81-.07v.98c.22.03.45.05.67.05,2.91,0,5.02-1.49,7.06-3.24.34.27,1.72.93,2.01,1.22-1.94,1.63-6.46,2.93-9.02,2.93-.25,0-.48-.01-.72-.04v1.37h11.07v-11.68h-11.08ZM13.75,17.76v.83c-2.69-.48-3.44-3.28-3.44-3.28,0,0,1.29-1.43,3.44-1.66v.91h0c-1.12-.14-2.01.92-2.01.92,0,0,.5,1.78,2.02,2.29M8.97,15.19s1.59-2.35,4.79-2.6v-.86c-3.54.29-6.59,3.28-6.59,3.28,0,0,1.73,5.01,6.59,5.46v-.91c-3.56-.44-4.78-4.37-4.78-4.37h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvidia);
export default __webpack_public_path__ + "static/media/Nvidia.a704136164757528c7e7c4b0e331f706.svg";
export { ForwardRef as ReactComponent };